export default "__VITE_ASSET__Bju7psTl__"